export const HEADERS = [
  { label: "หมายเลขเครื่องตัด", key: "deviceID" },
  { label: "หมายเลขรหัส PL", key: "deviceLotID" },
  { label: "รหัส SO", key: "soId" },
  { label: "รหัส Invoice", key: "invoiceId" },
  { label: "วันที่ Invoice", key: "invoiceDate" },
  { label: "Lot/เดือน", key: "lotMonth" },
  { label: "รหัสลูกค้า", key: "customerCode" },
  { label: "ชื่อลูกค้า", key: "customerName" },
  { label: "ลักษณะเครื่อง", key: "deviceType" },
  { label: "ขนาดเครื่อง", key: "deviceSize" },
];
